import React, { useEffect, useState, useRef } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faEdit, faFilePdf, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';
import RichTextEditor from '../../../../../components/RichTextEditor';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TabelaListagemFichas from '../../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Api
import documento_api from '../../../../../api/documento_api';
import variaveisSistema_api from '../../../../../api/variaveisSistema_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import downloadBase64File from '../../../../../helpers/downloadFile';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateDocumento() {
    return {
        identificacao: "",
        orientacoes: "",
        conteudo: "",
        arquivo: "",
        status: "Ativo",
        tipo: "",
        imagensConteudo: []
    }
}
export default function CadastroDocumento({ btnVoltar, id = null, editavel }) {
    //Estado de controle de visualização do modal de variaveis de substituição
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => setVisibleModal(!visibleModal);


    //Estado que guarda as variaveis para adicionar no documento
    const [variaveis, setVariaveis] = useState([
    ]);
    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Codigo", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ]

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "tipo", required: true }),
    ])

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos de cadastro de documento
    const [documento, setDocumento] = useState(initialStateDocumento());

    const { setLoading } = useAuth();

    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _documento = {
            ...documento,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_documento, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setDocumento(_documento);
    }

    //Função de on change do campo de tipo
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        const _campos = campos.filter(campo => campo.name !== "conteudo");
        const _documento = {
            ...documento,
            [name]: value
        };
        if (value === "Personalizado") {
            _documento.arquivo = "";
            setCampos([
                ..._campos,
                objCampo({ name: "conteudo", required: true }),
            ]);
        }

        setDocumento(_documento);
    }
    //Função de onChange do arquivo de anexo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setDocumento({
                ...documento,
                arquivo: base64
            });
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    }

    //Função para dar submit nos dados do documento
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(documento, campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        //Realizando o cadastro/edição do documento
        setLoading(true);
        const _documento = { ...documento }
        delete _documento.base64;
        if (documento.id) {
            documento_api.put(_documento).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o documento!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        } else {
            documento_api.post(_documento).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar o documento!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        }
    }

    //Função que salva as imagens base64 adicionadas no conteudo html
    const setImage = (base64, e) => {
        setDocumento({
            ...documento,
            [e.target.value]:e.target.value,
            imagensConteudo: [...documento.imagensConteudo ? documento.imagensConteudo : [], base64]
        })
    }


    //Função de load do documento para atualização
    const loadDocumento = () => {
        setLoading(true);
        documento_api.getItem(id).then(response => {
            setDocumento(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega as variaveis de sistema para subistituição no documento
    const loadVariaveisSistema = () => {
        setLoading(true);
        variaveisSistema_api.getList("Requerimento").then(response => {
            setVariaveis(response.data);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        if (id)
            loadDocumento();

        loadVariaveisSistema();
    }, []);

    return (
        <>
            <ModalCustomized btnClose={true} isOpen={visibleModal} toggle={toggleModal} title={"Variáveis de substituição"}>
                <TabelaListagemFichas headers={headers} items={variaveis} />
            </ModalCustomized>
            <Button onClick={btnVoltar} className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar</Button>
            <MainCard>
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h5 className='text-secondary'>Adicionar documento</h5>
                    {documento.tipo === "Personalizado" &&
                        <Button className='mt-2' onClick={toggleModal}><FontAwesomeIcon icon={faFileAlt} />  Variáveis de substituição</Button>
                    }
                </div>
                <Row>
                    <Col md="12" lg="5">
                        <TextField
                            label="* Identificação"
                            name={"identificacao"}
                            onChange={onChange}
                            value={documento.identificacao}
                            invalid={!!errors.identificacao}
                            maxLength={100}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Tipo"
                            name={"tipo"}
                            options={[
                                { label: "Personalizado", value: "Personalizado" },
                                { value: "Arquivo", label: "Arquivo" }
                            ]}
                            onChange={onChangeTipo}
                            value={documento.tipo}
                            invalid={!!errors.tipo}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            type={"radio"}
                            label="* Status"
                            name={"status"}
                            options={
                                [
                                    { label: "Ativo", value: "Ativo" },
                                    { value: "Inativo", label: "Inativo" }
                                ]
                            }
                            onChange={onChange}
                            value={documento.status}
                            invalid={!!errors.status}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            label="Orientações"
                            name={"orientacoes"}
                            type={"textarea"}
                            onChange={onChange}
                            value={documento.orientacoes}
                            invalid={!!errors.orientacoes}
                            maxLength={500}
                            disabled={!editavel} />
                    </Col>
                    {documento.tipo === "Arquivo" &&
                        <>
                            <Col md={documento.base64 ? "9" : "12"} lg={documento.base64 ? "9" : "12"}>
                                <TextField
                                    label="Arquivo"
                                    name={"arquivo"}
                                    type={"file"}
                                    onChange={onChangeAnexo}
                                    value={documento.arquivo}
                                    invalid={!!errors.arquivo}
                                    accept="application/pdf"
                                    disabled={!editavel} />
                            </Col>
                            {documento.base64 &&
                                <Col md="3" lg="3" >
                                    <Button
                                        className='w-100 mt-2'
                                        color='danger'
                                        onClick={() => downloadBase64File(documento.base64, documento.identificacao.trim() + '.pdf')}><FontAwesomeIcon icon={faFilePdf} /> Download PDF</Button>
                                </Col>
                            }
                        </>
                    }
                    {documento.tipo === "Personalizado" &&
                        <Col md="12" lg="12">
                            <RichTextEditor saveImage={setImage} name={"conteudo"} value={documento.conteudo} onChange={onChange} invalid={!!errors.conteudo} disabled={!editavel} />
                        </Col>
                    }
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mt-4'>
                        {
                            editavel &&
                            <Button className='px-4' color={id ? 'warning text-white' : 'success'} onClick={onSubmit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}</Button>
                        }
                    </Col>
                </Row>
            </MainCard>
        </>
    );
}